'use client';

import Link from 'next/link';

export default Link;
